import { type InjectionKey, inject, type Ref } from 'vue';

export const ServiceWorkerRegistrationInjectionKey = Symbol('ServiceWorkerRegistration') as InjectionKey<Ref<ServiceWorkerRegistration | undefined>>;

export function useServiceWorkerRegistration() {
  return inject(ServiceWorkerRegistrationInjectionKey)!;
}
